import React, { PropsWithChildren } from 'react';

export default function AdventureLeadIn(props: PropsWithChildren<{}>): JSX.Element {
  return (
    <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-8">
      <div className="col-span-1">{props.children}</div>
    </div>
  );
}
